import { Component, Input, TemplateRef, ViewChild } from '@angular/core';

@Component({
    selector: 'lib-chip-button-tabs-item',
    templateUrl: './chip-button-tabs-item.component.html',
    styleUrls: ['./chip-button-tabs-item.component.scss']
})
export class ChipButtonTabsItemComponent<T> {
    @Input() value!: T;
    @Input() hasIcon: boolean = false;
    @Input() qaTag: string = '';

    @ViewChild('content', {static: true, read: TemplateRef}) content!: TemplateRef<any>;
    @ViewChild('prefixIcon', {static: false, read: TemplateRef}) prefixIcon!: TemplateRef<any>;
}
